import React from "react";
import { Button, RadioGroup, Card, CardContent, Divider, Fab, FormControl, FormControlLabel, MenuItem, Pagination, Radio, Stack, Switch, TextField, Grow, Grid } from "@material-ui/core";
import {
  Typography,
  Box,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { goToLogin, goToPatients, goToProviders, goToUsers } from "../../../routes/Coordinator";
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import useForm from "../../../hooks/useForm";
import axios from "axios";
import { useEffect } from "react";
import InputMask from 'react-input-mask';

const filters = [
  {
    value: "name",
    label: "Nome",
  },
  {
    value: "email",
    label: "Email",
  },
  {
    value: "permition",
    label: "Permissão",
  },
];

function UseQuery() {
  return new URLSearchParams(window.location.search)
}

const ProviderRecord = () => {
  const [name, setName] = useState("")
  const [cpf_cnpj, setCpf_cnpj] = useState("")
  const [checkedcpf, setCheckedcpf] = useState(false);
  const [checkedcnpj, setCheckedcnpj] = useState(false);
  const navigate = useNavigate();



  const save = () => {
    let id = UseQuery().get("id")

    if (!id) {
      newProvider()
    } else {
      EditProvider()
    }
  }
  const newProvider = () => {
    axios.post(`${process.env.REACT_APP_BASE_URL}/providers`, { provider: { name, cpf_cnpj } },
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "token-type": localStorage.getItem("token-type"),
          "expiry": localStorage.getItem("expiry"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"

        }
      })
      .then((resposta) => {
        alert("Fornecedor cadastrado com sucesso!")
        goToProviders(navigate)
      })
      .catch((erro) => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      }
      )
  }
  const EditProvider = () => {

    let id = UseQuery().get("id")
    let url = `${process.env.REACT_APP_BASE_URL}/providers/${id}`
    axios.put(url, { provider: { name, cpf_cnpj } },
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        goToProviders(navigate)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const Show = () => {
    let id = UseQuery().get("id")
    if (id) {
      let url = `${process.env.REACT_APP_BASE_URL}/providers/${id}`

      axios.get(url,
        {
          headers: {
            "access-token": localStorage.getItem("access-token"),
            "client": localStorage.getItem("client"),
            "expiry": localStorage.getItem("expiry"),
            "token-type": localStorage.getItem("token-type"),
            "uid": localStorage.getItem("uid"),
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          setName(response.data.name)
          setCpf_cnpj(response.data.cpf_cnpj)
          if(response.data.cpf_cnpj.length === 14){
            setCheckedcpf(true)
          }else{
            setCheckedcnpj(true)
          }
        })
        .catch(erro => {
          Object.keys(erro.response.data).forEach((item) => {
            alert(erro.response.data[item]);
          });
          if (erro.response.status === 401) {
            goToLogin(navigate)
          }
        })
    }
  }

  useEffect(() => {
    Show()

  }, [])
  const iconCPF = (
    <Grid container columnSpacing={3}>
      <Grid item xs={12} md={12} lg={6}>
        <InputMask
          required
          id="outlined-required"
          onChange={(e) => setCpf_cnpj(e.target.value)}
          value={cpf_cnpj}
          name={"cpf_cnpj"}
          type={"text"}
          mask="999.999.999-99"
          disabled={false}
          variant={"outlined"}
          fullWidth

        >
          {() => <TextField fullWidth label={"CPF"} />}
        </InputMask>
      </Grid>
    </Grid>
  );
  const iconCNPJ = (
    <Grid container columnSpacing={3}>
      <Grid item xs={12} md={12} lg={6}>
        <InputMask
          required
          id="outlined-required"
          onChange={(e) => setCpf_cnpj(e.target.value)}
          value={cpf_cnpj}
          name={"cpf_cnpj"}
          type={"text"}
          mask="99.999.999/9999-99"
          disabled={false}
          variant={"outlined"}
          fullWidth

        >
          {() => <TextField fullWidth label={"CNPJ"} />}
        </InputMask>
      </Grid>
    </Grid>
  );


  const handleChangeCheckedCPF = (value) => {
    setCheckedcpf(value);
    setCheckedcnpj(!value);
  };
  const handleChangeCheckedCNPJ = (value) => {
    setCheckedcnpj(value);
    setCheckedcpf(!value);
  };
  return (
    <Box>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h3" sx={{ mb: 2 }}>Cadastrar Fornecedor</Typography>
          <Divider />
          <form>
            <Typography sx={{ paddingTop: 1 }} variant="h3">Dados</Typography>
            <CardContent
              sx={{
                padding: "30px",
              }}
            >
              <Grid container columnSpacing={3}>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    required
                    id="outlined-required"
                    label="Nome"
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                    name={"name"}
                    type={"name"}
                    fullWidth
                    sx={{
                      mb: 2,
                    }}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <CardContent
              sx={{
                padding: "30px",
              }}
            >
              <FormControlLabel
                control={<Switch checked={checkedcpf} onChange={(e) => handleChangeCheckedCPF(e.target.checked)}/>}
                label="CPF"
              />
              <Box sx={{ display: 'flex' }}>

                <Grow in={checkedcpf}>{iconCPF}</Grow>

              </Box>
              <FormControlLabel
                control={<Switch checked={checkedcnpj} onChange={(e) => handleChangeCheckedCNPJ(e.target.checked)} />}
                label="CNPJ"
              />
              <Box sx={{ display: 'flex' }}>

                <Grow in={checkedcnpj}>{iconCNPJ}</Grow>

              </Box>
            </CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <Box>
                <Button onClick={save} variant="contained" color="success" startIcon={<AddIcon />}>
                  Salvar
                </Button>
                <Button onClick={() => goToProviders(navigate)} variant="outlined" startIcon={<ArrowBackIosIcon />}>
                  Voltar
                </Button>
              </Box>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ProviderRecord;